<template>
  <div class="alert" :class="[variantClass]">
    <div class="flex items-center">
      <div
        class="alert__icon flex items-center justify-center"
        :class="[iconVariantClass]"
      >
        <slot name="icon">
          <img :src="icon_checkmark" alt="confirmation checkmark" />
        </slot>
      </div>
      <div>
        <div class="alert__title">{{ title }}</div>
        <div class="alert__subtitle">{{ subtitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import icon_checkmark from '@/assets/icon-checkmark.svg'

export default {
  name: 'ReservationAlert',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    variant: {
      type: String,
      default: 'success',
      validator: function(value) {
        return ['success', 'warning', 'info'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      icon_checkmark,
      variantClass: `alert--${this.variant}`,
      iconVariantClass: `alert__icon--${this.variant}`,
    }
  },
}
</script>

<style lang="scss" scoped>
.alert {
  position: relative;
  height: auto;

  padding: 1.7rem 2rem;
  margin-bottom: 0;

  border-radius: $border-radius-default;

  text-align: left;

  color: $white;

  &--fullWidth {
    margin: 1rem;

    @include xs {
      margin: -1rem;
    }
  }

  @include xs {
    border-radius: 0;
    padding: 1.7rem 1.5rem;
    margin-bottom: 0;
  }

  &--info {
    background: white;
    border: 1px solid $silver;

    .alert__title {
      color: $black-10;
    }
    .alert__subtitle {
      color: $body-grey-t;
    }
  }

  &--warning {
    background: white;
    border: 1px solid $silver;

    .alert__title {
      color: $black-10;
    }
    .alert__subtitle {
      color: $body-grey-t;
    }
  }
}

.alert__icon {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  margin-right: 1.5rem;
  flex-shrink: 0;

  @include xs {
    margin-right: 1rem;
  }

  &--info {
    background: $black-10;
  }
  &--warning {
    background: #d34a20;
  }
}

.alert__title {
  @extend %title;
  @extend %black;

  margin-bottom: 0.5rem;
}

.alert__subtitle {
  @extend %body;

  color: transparentize($white, 0.28);
}
</style>
